import { SETTINGS_FOLD_WIDTH, useElementSize } from "@salestrak/ui";

/**
 * The width under which a widget body is COMPACT: the rung the card header
 * folds Settings into its menu at (`SETTINGS_FOLD_WIDTH` in the kit), so a
 * body and its header change shape at the same width. A row list drops its
 * secondary words here (a type, a location) and keeps the identity and the
 * trailing fact; a table keeps its name column alone.
 *
 * Measured, never the grid span: a span is a fraction of a grid whose pixel
 * size the card cannot know, so the same span is roomy on a wide monitor and
 * cramped in a split window. The viewport is the wrong axis too — a card
 * is a column inside a page, and its width is its own.
 */
export const COMPACT_BODY_WIDTH = SETTINGS_FOLD_WIDTH;

/**
 * Attach `ref` to the body's root and read `compact`. Zero means "not measured
 * yet" and reads as roomy, so the first paint never flashes the folded form
 * on a wide card.
 */
export function useCompactBody<T extends HTMLElement = HTMLDivElement>(): {
  ref: ReturnType<typeof useElementSize<T>>["ref"];
  compact: boolean;
} {
  const { ref, size } = useElementSize<T>();
  return { ref, compact: size.width > 0 && size.width < COMPACT_BODY_WIDTH };
}
